import * as React from 'react';
import { useEffect, useState } from 'react';

import { UseItemTooltipReturnValue } from '@mui/x-charts/ChartsTooltip';
import { ChartSeriesType } from '@mui/x-charts/internals';

/**
 * Render a basic tooltip content for an item.
 */
export function CustomItemTooltipContent(
  props: Pick<UseItemTooltipReturnValue<ChartSeriesType>, 'color' | 'label' | 'formattedValue'>
) {
  const formattedValue = props.formattedValue;
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleScroll = () => {
      setIsVisible(false);
      // Reset visibility after scroll stops
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsVisible(true);
      }, 150); // Adjust delay as needed
    };

    document.addEventListener('scroll', handleScroll, true);

    return () => {
      document.removeEventListener('scroll', handleScroll, true);
      clearTimeout(timeoutId);
    };
  }, []);

  if (!isVisible) return null;

  // Container styles
  const containerStyle: React.CSSProperties = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  };

  // Text styles
  const textStyle: React.CSSProperties = {
    fontSize: '12px',
    fontWeight: 600,
    color: '#1f2937',
  };

  return (
    <>
      {/* CSS for pseudo-element */}
      <style jsx>{`
        .financial-card::after {
          content: '';
          position: absolute;
          width: 8px;
          height: 8px;
          background-color: white;
          transform: rotate(45deg);
          bottom: -4px;
          left: 50%;
          margin-left: -4px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
      `}</style>

      <div className="financial-card" style={containerStyle}>
        <div style={textStyle}>{formattedValue}</div>
      </div>
    </>
  );
}
